import React from 'react'
import styled from 'styled-components'
import { useTheme } from '@mui/material'

import NewsCard from '../../compositions/newsCard'
import WidthContainer from '../../elements/widthContainer'

import TypographyElement from '../../elements/typography'
import ButtonElement from '../../elements/buttons'

const Container = styled.div`
  background: ${(props) => props.background};
  padding: 70px 220px;
  padding: ${(props) => (props.noPadding ? '0' : '70px 220px')};
  .news {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    gap: 2%;
  }

  .button {
    text-align: right;
    a {
      text-align: center;
    }

    @media screen and (max-width: 600px) {
      svg {
        display: none;
      }
    }
  }
`

const NewsShortSection = ({
  title,
  news,
  button,
  hasBackground = false,
  inArticle = false,
}) => {
  const theme = useTheme()

  news = news.slice(0, 3)

  const widthVariant = inArticle ? 'small' : 'full'
  return (
    <WidthContainer variant={widthVariant}>
      <Container
        noPadding={inArticle}
        background={
          hasBackground
            ? theme?.globalTheme?.palette?.backgroundColor?.main
            : 'transparent'
        }
      >
        <TypographyElement variant="moreTitle" component="h2">
          {title}
        </TypographyElement>
        <div className="news">
          {news?.map((item, index) => {
            return (
              <NewsCard
                {...item}
                isLarge={false}
                decorativeOnly={true}
                key={`newsitem-${index}`}
              />
            )
          })}
        </div>
        {button?.href && (
          <div className="button">
            <ButtonElement variant="primaryLink" href={button.href}>
              {button.text}
            </ButtonElement>
          </div>
        )}
      </Container>
    </WidthContainer>
  )
}

export default NewsShortSection
